module.exports = __webpack_public_path__ + "img/中文版_库尔_天津.dc469c37.webp";